import { Municipality } from "@app/project/model/municipality";
import { ActionPayloadGeneric } from "@app/root-store/actions";
import { createActionSet, createCrudActionSets, createNoPropsAction } from "@app/root-store/actions/action-creators";

type ActionPayload = ActionPayloadGeneric & {
    municipality: Municipality;
};

interface LoadActionPayload {
    projectId: number;
}

interface ActionResult {
    municipality: Municipality;
}

const actionCategory = "Municipality";

export const {
    load: loadSet,
    update: updateSet,
    clear: clearSet,
} = createCrudActionSets<ActionPayload, LoadActionPayload, ActionResult, ActionResult>(actionCategory);

export const createSet = createActionSet<{ municipality: Municipality } & ActionPayloadGeneric, ActionResult>(actionCategory, "Create");

export const { request: load, success: loadSuccess, failure: loadFailure } = loadSet;
export const { request: create, success: createSuccess, failure: createFailure } = createSet;
export const { request: update, success: updateSuccess, failure: updateFailure } = updateSet;
/**
 * An action to clear the data in the store
 */
export const clear = createNoPropsAction(actionCategory, "Clear State");
